import React, { useState } from 'react';
import { Save } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { updateAdmin, verifyToken, changePassword } from '../../api/api';

export const AdminSettings = () => {
  const [username, setUsername] = useState('admin');
  const [adminEmail, setAdminEmail] = useState('zeroundprod@gmail.com');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  React.useEffect(() => {
    const fetchAdmin = async () => {
      try {
        const { username: user, email } = await verifyToken();
        setUsername(user);
        setAdminEmail(email);
      } catch (e) {}
    };
    fetchAdmin();
  }, []);

  const handleUsernameChange = async (e) => {
    e.preventDefault();
    try {
      await updateAdmin(username, adminEmail);
      toast.success("Compte mis à jour avec succès !");
    } catch (e) {
      toast.error(e.message || "Erreur lors de la mise à jour");
    }
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      toast.error("Les mots de passe ne correspondent pas");
      return;
    }
    try {
      await changePassword(oldPassword, newPassword);
      toast.success("Mot de passe modifié avec succès !");
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur lors du changement de mot de passe");
    }
  };

  return (
    <div>
      <h2 className="text-3xl font-bold text-gray-900 mb-8">Paramètres</h2>

      <Card className="max-w-2xl mb-6">
        <CardHeader><CardTitle>Compte Admin</CardTitle></CardHeader>
        <CardContent>
          <form onSubmit={handleUsernameChange} className="space-y-4">
            <div><Label htmlFor="username">Nom d'utilisateur</Label><Input id="username" type="text" value={username} onChange={(e) => setUsername(e.target.value)} required /></div>
            <div><Label htmlFor="adminEmail">Email admin (pour récupération mot de passe)</Label><Input id="adminEmail" type="email" value={adminEmail} onChange={(e) => setAdminEmail(e.target.value)} required /></div>
            <Button type="submit" className="bg-[#FF1B6D] hover:bg-[#E01660]"><Save size={18} className="mr-2" />Enregistrer</Button>
          </form>
        </CardContent>
      </Card>

      <Card className="max-w-2xl">
        <CardHeader><CardTitle>Changer le mot de passe</CardTitle></CardHeader>
        <CardContent>
          <form onSubmit={handlePasswordChange} className="space-y-4">
            <div><Label htmlFor="oldPassword">Ancien mot de passe</Label><Input id="oldPassword" type="password" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} required /></div>
            <div><Label htmlFor="newPassword">Nouveau mot de passe</Label><Input id="newPassword" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required /></div>
            <div><Label htmlFor="confirmPassword">Confirmer le mot de passe</Label><Input id="confirmPassword" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required /></div>
            <Button type="submit" className="bg-[#FF1B6D] hover:bg-[#E01660]"><Save size={18} className="mr-2" />Enregistrer</Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
